import { render } from "./CustomerOrdering.vue?vue&type=template&id=760eb5d3&scoped=true"
import script from "./CustomerOrdering.vue?vue&type=script&lang=js"
export * from "./CustomerOrdering.vue?vue&type=script&lang=js"

import "./CustomerOrdering.vue?vue&type=style&index=0&id=760eb5d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760eb5d3"]])

export default __exports__